<template>
    <div class="profile_edit_content_block">
        <Breadcrumbs :type="type" :header="title" :url="url" :head="head"></Breadcrumbs>
        <trashed-message v-if="queue_office.deleted_at" class="mb-6" @restore="restore"> This Data has been deleted.
        </trashed-message>
        <div class="w-full bg-white rounded-md shadow overflow-hidden edit_form_block">
            <form @submit.prevent="update">
                <div class="grid grid-cols-1 gap-y-4 gap-x-4 sm:grid-cols-6 mt-3 p-4">
                    <text-input v-model="form.office_name" :error="form.errors.office_name" class="sm:col-span-2"
                        label="Office Name" required="true" placeholder="i.e. Lgu Office" />
                    <text-input v-model="form.code" :error="form.errors.code" class="sm:col-span-2" label="Code"
                        required="true" placeholder="i.e 0100" />
                    <text-input v-model="form.user_name" :error="form.errors.user_name" class="sm:col-span-2"
                        label="User Name" required="true" placeholder="i.e lgubutig" />
                    <text-input v-model="form.password" :error="form.errors.password" class="sm:col-span-2"
                        label="Password" placeholder="i.e *****" />
                    <select-input-function v-model="form.office_layer_id" :error="form.errors.office_layer_id"
                        class="sm:col-span-2" label="Name of Office Layer" :action="loadOffice">
                        <option value=null>Select Office Layer</option>
                        <option v-for="officelayer in officelayers" :key="officelayer.id" :value='officelayer.id'>{{
                            officelayer.office_layer_name }}</option>
                    </select-input-function>
                    <template v-if="showministry">
                        <select-input-function v-model="form.ministry_id" :error="form.errors.ministry_id"
                            class="sm:col-span-2" label="Ministry" :action="loadOffice">
                            <option value=null>Select Ministry</option>
                            <option v-for="ministry in ministries" :key="ministry.id" :value='ministry.id'>{{
                                ministry.ministry_name }}</option>
                        </select-input-function>
                    </template>
                    <template v-if="showregion == true">
                        <select-input-function v-model="form.region_id" :error="form.errors.region_id"
                            class="sm:col-span-2" label="Name of Region" :action="load_province">
                            <option value=null>Select Region</option>
                            <option v-for="region in regions" :key="region.id" :value='region.id'>{{ region.region_name
                                }}</option>
                        </select-input-function>
                    </template>
                    <template v-if="showprovience == true">
                        <select-input-function v-model="form.province_id" :error="form.errors.province_id"
                            class="sm:col-span-2" label="Name of Province" :action="load_municipality">
                            <option value=null>Select Province</option>
                            <option v-for="province in province_list" :key="province.id" :value='province.id'>{{
                                province.provience_name }}</option>
                        </select-input-function>
                    </template>
                    <template v-if="showmunicipality == true">
                        <select-input-function v-model="form.municipality_id" :error="form.errors.municipality_id"
                            class="sm:col-span-2" label="Name of Municipality" :action="load_barangay">
                            <option value=null>Select Municipality</option>
                            <option v-for="municipal in municipality_list" :key="municipal.id" :value='municipal.id'>{{
                                municipal.municipality_name }}</option>
                        </select-input-function>
                    </template>
                    <template v-if="showbarangay == true">
                        <select-input-function v-model="form.barangay_id" :error="form.errors.barangay_id"
                            class="sm:col-span-2" label="Name of Barangay" id="barangay_id" :action="loadOffice">
                            <option value=null>Select Barangay</option>
                            <option v-for="barangay in barangay_list" :key="barangay.id" :value='barangay.id'>{{
                                barangay.barangay_name }}</option>
                        </select-input-function>
                    </template>
                    <select-input-function v-model="form.office_id" :error="form.errors.office_id" class="sm:col-span-2"
                        label="Name of Office">
                        <option value=null>Select Office</option>
                        <option v-for="office in offices" :value='office.id'>{{ office.office_name }}</option>
                    </select-input-function>
                    <status-toogle-button v-model="form.status" :error="form.errors.status" label="Office Status"
                        class="sm:col-span-2 "></status-toogle-button>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <Button v-if="permission.edit > 0" :type="type" :name="head" :url="createUrl"
                        :loading="form.processing"></Button>
                </div>
            </form>
        </div>
        <!-- <pre>
        {{ form }}
      </pre> -->
    </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import { ref, toRefs, inject, onMounted, watch } from 'vue'
import axios from 'axios';
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import SelectInputFunction from '@/Shared/SelectInputFunction'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import StatusToogleButton from '@/Shared/StatusToogleButton'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import DeleteIcon from '@/Shared/DeleteIcon'
import Button from '@/Shared/Button'
import PhotoBlock from './Photo';
export default {
    components: {
        Head,
        Icon,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
        StatusToogleButton,
        Breadcrumbs,
        DeleteIcon,
        Button,
        TextareaInput,
        PhotoBlock,
        SelectInputFunction
    },
    layout: Layout,
    props: {
        queue_office: Object,
        officelayers: Array,
        ministries: Array,
        regions: Array,
        permission: Object
    },
    remember: 'form',
    setup(props) {
        const { queue_office, permission, regions, ministries, officelayers } = toRefs(props)
        const type = ref('edit')
        const title = ref(queue_office.value.office_name)
        const head = ref('Queue Office')
        const url = ref('/backend/queue-offices')
        const createUrl = ref('')
        const swal = inject('$swal')
        const elm = ref(this)
        const form = useForm({
            office_name: queue_office.value.office_name,
            code: queue_office.value.code,
            hierarchy: queue_office.value.hierarchy,
            office_layer_id: queue_office.value.office_layer_id,
            office_id: queue_office.value.office_id,
            ministry_id: queue_office.value.ministry_id,
            region_id: queue_office.value.region_id,
            province_id: queue_office.value.province_id,
            municipality_id: queue_office.value.municipality_id,
            barangay_id: queue_office.value.barangay_id,
            user_name: queue_office.value.user_name,
            password: null,
            status: queue_office.value.status,
        })
        const showministry = ref(false)
        const showregion = ref(false)
        const showprovience = ref(false)
        const showmunicipality = ref(false)
        const showbarangay = ref(false)
        const offices = ref([])
        const backendPrefix = ref(process.env.MIX_ADMIN_PREFIX)

        const update = () => {
            swal({
                title: 'Are you sure?',
                text: "You want to proceed with this action",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
            }).then((result) => {
                if (result.isConfirmed) {
                    form.put(`${url.value}/${queue_office.value.id}`)
                    title.value = form.office_name
                    swal.fire(
                        'Updated!',
                        'Your infomation has been Updated.',
                        'success'
                    )
                }
            });
        }
        const destroy = () => {
            swal({
                title: 'Are you sure?',
                text: "Do you really want to delete this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    form.delete(`${url.value}/${queue_office.value.id}`)
                    swal.fire(
                        'Deleted!',
                        'Your infomation has been deleted.',
                        'success'
                    )
                }
            });
        }
        const restore = () => {
            swal({
                title: 'Are you sure?',
                text: "You want to restore this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Resore it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    form.put(`${url.value}/${queue_office.value.id}/restore`)
                    swal.fire(
                        'Restored!',
                        'Your infomation has been Restored.',
                        'success'
                    )
                }
            });
        }

        const province_list = ref([])
        const load_province = async () => {
            if (form.region_id > 0) {
                province_list.value = []
                let data = {
                    geo_region_id: form.region_id
                }
                await axios.post(`/${backendPrefix.value}/provinces/activeprovinces`, data)
                    .then(function (response) {
                        province_list.value = response.data
                        // form.province_id = null
                        // form.municipality_id = null
                        // form.barangay_id = null
                        if (form.province_id) load_municipality(1)
                    }.bind(this));
            }


        }
        const municipality_list = ref([])
        const load_municipality = async () => {
            if (form.province_id > 0) {
                municipality_list.value = []
                let data = {
                    geo_provience_id: form.province_id
                }
                await axios.post(`/${backendPrefix.value}/municipalities/activemunicipalities`, data)
                    .then(function (response) {
                        console.log('hello:', response);
                        // form.municipality_id = null
                        // form.barangay_id = null
                        municipality_list.value = response.data
                        if (form.municipality_id) load_barangay(2)
                    }.bind(this));
            }

        }

        const barangay_list = ref([])
        const load_barangay = async () => {
            if (form.municipality_id > 0) {
                barangay_list.value = []
                let data = {
                    geo_municipality_id: form.municipality_id
                }
                await axios.post(`/${backendPrefix.value}/barangays/activebarangays`, data)
                    .then(function (response) {
                        // form.barangay_id = null
                        barangay_list.value = response.data
                    }.bind(this));
            }

        }
        const load_data = async () => {
            if (form.office_layer_id == 1) {
                showministry.value = true
                showregion.value = false
                showprovience.value = false
                showmunicipality.value = false
                showbarangay.value = false
            } else if (form.office_layer_id == 2) {
                showministry.value = false
                showregion.value = true
                showprovience.value = false
                showmunicipality.value = false
                showbarangay.value = false
            } else if (form.office_layer_id == 3) {
                showministry.value = false
                showregion.value = true
                showprovience.value = true
                showmunicipality.value = false
                showbarangay.value = false
            } else if (form.office_layer_id == 4) {
                showministry.value = false
                showregion.value = true
                showprovience.value = true
                showmunicipality.value = true
                showbarangay.value = false
            } else if (form.office_layer_id == 5) {
                showministry.value = false
                showregion.value = true
                showprovience.value = true
                showmunicipality.value = true
                showbarangay.value = true
            }
        }
        const load_offices = async () => {
            let data = {
                office_layer_id: form.office_layer_id,
                ministry_id: form.ministry_id,
                geo_region_id: form.region_id,
                geo_province_id: form.province_id,
                geo_municipality_id: form.municipality_id,
                geo_barangay_id: form.barangay_id,
            }
            await axios.post(`/${backendPrefix.value}/geomapping/load-offices`, { data: data })
                .then(function (response) {
                    offices.value = response.data
                })
        }
        watch(() => form.office_layer_id, () => {
            load_data()
        })

        watch(() => form, async () => {
            load_offices()
        }, { deep: true })

        onMounted(() => {
            load_province()
            load_data()
            load_offices()
        })
        return {
            form,
            queue_office,
            type,
            title,
            head,
            url,
            createUrl,
            update,
            destroy,
            restore,
            swal,
            permission,
            regions,
            ministries,
            permission,
            province_list,
            load_province,
            municipality_list,
            load_municipality,
            barangay_list,
            load_barangay,
            showministry,
            showregion,
            showprovience,
            showmunicipality,
            showbarangay,
            offices,
            officelayers,
            ministries,
            backendPrefix
        }
    }
}
</script>
